import one from '../assets/svg/projects/one.svg'
// import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Customer Onboarding and billing portal',
        projectDesc: 'Developed a solution to manage users and billing in a PaaS platform. This system handles multi-platform customer usage, as well as recurring, daily and monthly Tariff management along with tax filing.',
        tags: ['NEUDHI23 Official Project'],
        code: 'https://gitlab.com/ashumishrapayashi/accontDesk',
        demo: 'https://gitlab.com/ashumishrapayashi/accontDesk/-/blob/main/README.md?ref_type=heads',
        image: one
    },
   
    {
        id: 3,
        projectName: 'Vedic',
        projectDesc: 'This project aims to build a disease prediction system based on 5-6 symtoms/',
        tags: ['Flask', 'Machine Learning'],
        code: 'https://gitlab.com/ashumishrapayashi/Vedic',
        demo: 'https://gitlab.com/ashumishrapayashi/Vedic/-/blob/main/README.md?ref_type=heads',
        image: 'https://www.svgrepo.com/show/147416/doctor.svg'
    },
    {
        id: 4,
        projectName: 'Commodity and Market Intelligence',
        projectDesc: 'Developed a solution combining Spend Analytics, Process Mining algorithms, and custom workflow rules to optimize processes and manage spending efficiently across organizations globally',
        tags: ['NEUDHI23 Official Project'],
        code: 'https://github.com/devbyashu/',
        demo: 'https://github.com/devbyashu/',
        image: "https://cdn-gmlal.nitrocdn.com/COEFSwWOUXelieQTcxnmdtQFhbuAVPuh/assets/images/optimized/rev-5e02bcd/www.enverus.com/wp-content/uploads/2023/08/marketview-sample.png"
    },
    {
        id: 7,
        projectName: 'StockCraft',
        projectDesc: 'StockCraft online trading game which allows you to buy and sell stocks at your convenience and at the current market price. The player at the end with highest total stocks and cash wins the game.',
        tags: ['Django', 'HTML', 'CSS', 'JS', 'redis'],
        code: 'https://gitlab.com/ashumishrapayashi/StockCraft',
        demo: 'https://gitlab.com/ashumishrapayashi/StockCraft/-/blob/main/README.md?ref_type=heads',
        image: seven
    },
    {
        id: 2,
        projectName: 'Ajax-File',
        projectDesc: 'This project is a file uploader system that allows users to upload more then 20 extention data file and then it will parse that file in a appropriate JSON,CSV,XML dataformat.',
        tags: ['Django', 'Tailwind CSS'],
        code: 'https://gitlab.com/ashumishrapayashi/ajax-file',
        demo: 'https://gitlab.com/ashumishrapayashi/ajax-file/-/blob/main/README.md?ref_type=heads',
        image: three
    },
   
    {
        id: 5,
        projectName: 'FimoDuck',
        projectDesc:'"A food delivery platform for multiple vendors to list restaurants, get approval, and add food products. Includes vendor and client control panels."',
        tags: ['React', 'Node JS', 'GraphQL', 'Rest API'],
        code: 'https://gitlab.com/devbyashu/',
        demo: 'https://gitlab.com/devbyashu/',
        image: 'https://www.shift4shop.com/2015/images/industries/food-beverages/food-beverages.png'
    },
    {
        id: 6,
        projectName: 'FimoDuck Driver',
        projectDesc:"This module extends FimoDuck, a food delivery platform, with web and mobile apps for delivery personnel to manage orders and earnings.",
        tags: ['React', 'Node JS'],
        code: 'https://gitlab.com/devbyashu/',
        demo: 'https://gitlab.com/devbyashu/',
        image: five
    },
    {
        id: 8,
        projectName: 'SIP/STP Automation',
        projectDesc:"Automated investments with OAuth2.0, real-time monitoring, KYC/AML checks, and SEBI compliance for secure, high-frequency mutual fund transactions.",
        tags: ['NEUDHI23 Official Project'],
        code: 'https://gitlab.com/devbyashu/',
        demo: 'https://gitlab.com/ashumishrapayashi/',
        image: ""
    },
    {
        id: 8,
        projectName: '2D House Plan Extractor',
        projectDesc:"Developed an OCR-based tool for extracting 2D house plan data from images, PDFs, and drawings using transformers and Milvus.",
        tags: ['NEUDHI23 Official Project'],
        code: 'https://gitlab.com/devbyashu/',
        demo: 'https://gitlab.com/devbyashu/',
        image: ""
    },
    // {
    //     id: 8,
    //     projectName: 'Bet-Haggle',
    //     projectDesc: 'A proof of transection based project which stores and manage NFT of invoice data in to the blockchain.',
    //     tags: ['Solidity', 'Node JS'],
    //     code: 'https://gitlab.com/ashumishrapayashi/bet-haggle',
    //     demo: 'https://gitlab.com/ashumishrapayashi/bet-haggle/-/blob/main/README.md?ref_type=heads',
    //     image: 'https://pic.onlinewebfonts.com/svg/img_83039.svg'
    // },
]
